export default {
  viewBox: "0 0 24 24",
  paths: [
    "M22,5.5H3.5c-0.4,0-0.8-0.3-0.8-0.8S3.1,4,3.5,4H22c0.4,0,0.8,0.3,0.8,0.8S22.5,5.5,22,5.5z",
    "M22,18.5H3.5c-0.4,0-0.8-0.3-0.8-0.8S3.1,17,3.5,17H22c0.4,0,0.8,0.3,0.8,0.8S22.5,18.5,22,18.5z"
  ]
};